import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Overlay, Popover } from 'react-bootstrap'

let idNo = 0

const ButtonWithTooltip = ({
  id = null,
  className = '',
  tooltip = null,
  tooltipOptions: {
    placement: tooltipPlacement = 'bottom',
    activeOnDisabled: tooltipActiveOnDisabled = true,
  } = {},
  onClick = null,
  disabled = false,
  selected = false,
  children,
}) => {
  const [buttonId] = useState(id || `button-${idNo++}`) // eslint-disable-line
  const [showTooltip, setShowTooltip] = useState(false)

  const target = useRef(null)

  const handleTooltip = (on) => {
    if (!tooltip) {
      return
    }
    if (disabled && !tooltipActiveOnDisabled) {
      // hide tootip when button become disabled
      setShowTooltip(false)
    } else {
      // button configured for hovering tooltips, from hover event
      setShowTooltip(on)
    }
  }

  const handleClick = (event) => {
    if (onClick && typeof onClick === 'function') {
      onClick(event)
    }
  }

  const handleMouseEnter = () => {
    handleTooltip(true)
  }

  const handleMouseLeave = () => {
    handleTooltip(false)
  }

  const classes = ['buttonWithTooltip']
  if (selected) {
    classes.push('selectedButton')
  }
  if (disabled) {
    classes.push('disabled')
  }
  if (className) {
    classes.push(className)
  }

  return (
    <React.Fragment>
      <div
        ref={target}
        className='buttonWrapper'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <button
          className={classes.join(' ')}
          id={buttonId}
          onClick={handleClick}
          disabled={disabled}
        >
          {children}
        </button>
        {disabled && tooltip && tooltipActiveOnDisabled &&
          // transparent overlay over the disabled button
          // so the browser send correctly mouseEnter, mouseLeave
          <div className={'disableOverlay'}></div>
        }
      </div>
      {tooltip &&
        <Overlay
          target={target.current}
          show={showTooltip}
          placement={tooltipPlacement}
          transition={true}
        >
          <Popover id={`${buttonId}-tooltip`} bsPrefix={`popover appTooltip ${disabled ? 'disabled' : ''}`}>
            <Popover.Content>
              { tooltip }
            </Popover.Content>
          </Popover>
        </Overlay>
      }
    </React.Fragment>
  )
}

ButtonWithTooltip.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  tooltip: PropTypes.node,
  tooltipOptions: PropTypes.shape({
    placement: PropTypes.string,
    activeOnDisabled: PropTypes.bool,
  }),
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
}

export default ButtonWithTooltip
